// extracted by mini-css-extract-plugin
export default {"heading":"_3TsOJ_ZdwmHoIhjUEjYtgo","headingContainer":"oqg2MIrQt_M0HeqFGjxiD"};